require("./brokerConvenienceConfirmationSuccess.scss")

// @vendors
const React = require("react");
const PropTypes = require("prop-types");

// @commons
const { OKButton } = require("components/commons/OKButton/OKButton");
const { OKMessage } = require("commonsComponents/OKMessage");

// @utilities
const { FormattedText } = require("core/i18n").i18n;
const { buildTestScoreInfo } = require("mifid/utilities/mifidTestTextHelper");

class BrokerConvenienceConfirmationSuccess extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { immBrokerConvenienceMiFIDTest } =  this.props;
        const immMifidv2 = immBrokerConvenienceMiFIDTest.get('mifidv2');
        const reason = immMifidv2.get('reason');

        const customData = {
            nombrePagina: "tu-inviertes/test-mifid",
            tipoProceso: "proc-tu-inviertes-test-mifid",
            pasoProceso: "exito",
            detalleProceso:  reason.toString() === '1' ? "no conveniente" : "conveniente",
        }

        window &&
            window.utag &&
            window.utag.view &&
            window.utag.view(customData);
    }

    render() {
        const { immBrokerConvenienceMiFIDTest } =  this.props;
        const immMifidv2 = immBrokerConvenienceMiFIDTest.get('mifidv2');
        const reason = immMifidv2.get('reason');
        return (
            <React.Fragment>
                <div className="convenience-test-success__top-disclaimer no-print-out">
                    <FormattedText value="broker-convenienceMifidSuccessHeaderTitle"/>
                </div>
                <div className="convenience-test-success__profile-section">
                    <div className="convenience-test-success__details-header">
                        <div className="convenience-test-success__details-icon-success" />
                        <h3 className="convenience-test-success__details-title">
                            <FormattedText value="broker-convenienceMifidSuccessTitle"/>
                        </h3>
                    </div>


                    <div className="convenience-test-success__details-body">
                        <div className="convenience-test-success__details-separator"/>
                        <div className="convenience-test-success__details-body-title">
                            <FormattedText value="broker-convenienceMifidSuccessDetailTitle"/>
                        </div>
                        <div className="convenience-test-success__details-body-result">
                            {buildTestScoreInfo(reason)}
                        </div>
                    </div>

                    <div className="convenience-test-success__info-text">
                        <OKMessage type={"informative"}>
                            <div className="ra-goal-notification__info">
                                <FormattedText value="broker-convenienceMifidSuccessDisclaimer"
                                    injectedStrings={[immMifidv2.get('expirationYears')]}
                                />
                            </div>
                        </OKMessage>
                    </div>
                    <div className="convenience-test-success__details-footer">
                        <OKButton
                            onClick={this.props.goToFinishTest} modifier="primary"
                        >
                            <FormattedText value="broker-convenienceMifidSuccessContinueCTA"/>
                        </OKButton>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
BrokerConvenienceConfirmationSuccess.propTypes = {
    goToFinishTest: PropTypes.func,
    title: PropTypes.string,
    immBrokerConvenienceMiFIDTest: PropTypes.object,
}

module.exports = BrokerConvenienceConfirmationSuccess;
